module.exports = __webpack_public_path__ + "static/media/carousel_lettuce_5.ba047e62.jpg";